'use client';
import { BASE_URL, BORDER_COLORS, COLORS, USE_SOCKETVIEW } from '@/common/constants';
import { getWebsiteCodeHeader } from '@/common/pageConfig';
import { useRecaptcha } from '@/common/useRecaptcha';
import { useTranslations } from 'next-intl';
import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { twMerge } from 'tailwind-merge';
const formatNumber = (num) => {
  return num.toLocaleString();
};

function getDeviceId() {
  const key = 'deviceId';
  const random9DigitNumber = Math.floor(Math.random() * 900000000).toString();
  let deviceId = localStorage.getItem(key);

  if (!deviceId) {
    // Tạo ID ngẫu nhiên (UUID)
    deviceId = random9DigitNumber;
    localStorage.setItem(key, deviceId);
  }

  return deviceId;
  //   return random9DigitNumber;
}

async function getViews(code) {
  try {
    const res = await fetch(`${BASE_URL}/staticalViewDays/getTodayView`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(code),
        'Content-Type': 'application/json',
      },
    });
    const response = await res.json();
    return response;
  } catch {
    return [];
  }
}

const handleSubmitDownView = async () => {
  try {
    const recaptchaToken = await execute('submit');
    await fetch(`${BASE_URL}/staticalViewDays/disconnectToWeb?idSocket=${getDeviceId()}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        recaptchaToken,
      }),
    });
  } catch {
    // alert(`Có lỗi xảy ra! ${error}`);
  }
};

function isMobile() {
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

const AccessInformation = ({ websiteCode }) => {
  let socket;
  let hasSentUpView = false;
  const [dataViews, setDataViews] = useState({});
  // socket connect lỗi thì với gọi up view bằng api tt
  let isSocketError = false;
  const { execute } = useRecaptcha();
  let isSocketConnected = false;
  const t = useTranslations('');
  const fetchViews = async (code) => {
    let res = await getViews(code);
    if (typeof res.socketIdWithUser !== 'undefined') {
      const socketIdWithUser = res.socketIdWithUser;
      if (socketIdWithUser.findIndex((item) => item.id === getDeviceId()) === -1) {
        res.totalView = (res?.totalView ?? 0) + 1;
        socketIdWithUser.push({
          id: getDeviceId(),
          date: new Date().toISOString(),
        });
      }
      res = {
        ...res,
        socketIdWithUser,
        lastConnectView: socketIdWithUser.length,
      };
    }
    setDataViews(res);
  };

  useEffect(() => {
    fetchViews(websiteCode);
  }, [websiteCode]);
  const handleSubmitUpView = async (isFirst) => {
    if (hasSentUpView) return; // tránh gọi lại
    hasSentUpView = true;
    setTimeout(async () => {
      try {
        const recaptchaToken = await execute('submit');

        await fetch(`${BASE_URL}/staticalViewDays/connectToWeb`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            idSocket: getDeviceId(),
            isFirst,
            recaptchaToken,
          }),
        });
      } catch {
        //
      }
    }, 5000);
  };

  useEffect(() => {
    if (USE_SOCKETVIEW === '1') {
      socket = io(BASE_URL.replace('/v1', ''));
      try {
        socket.on('connect_error', () => {
          if (!isSocketError) {
            isSocketError = true;
            handleSubmitUpView(true);
          }
        });

        socket.on('connect', () => {
          if (!isSocketConnected) {
            isSocketConnected = true;
            socket.emit('f', {
              function: 'view',
              deviceId: getDeviceId(),
              isFirst: true,
            });
          }
        });
        socket.on('dataView', (data) => {
          setDataViews(data);
        });
      } catch {
        // console.error(error);
        handleSubmitUpView(true);
      }
    } else {
      handleSubmitUpView(true);
    }
    setTimeout(() => {
      if (!isSocketConnected) {
        setInterval(() => {
          fetchViews();
        }, 1000 * 30);
      }
    }, 10 * 1000);
    const handleBeforeUnload = async () => {
      try {
        if (isSocketConnected) {
          socket.emit('f', {
            function: 'dis-view',
            deviceId: getDeviceId(),
          });
        } else {
          handleSubmitDownView();
        }
      } catch {}
    };

    const handleFocus = () => {
      if (isSocketConnected) {
        socket.emit('f', {
          function: 'view',
          deviceId: getDeviceId(),
        });
      } else {
        handleSubmitUpView();
      }
    };

    if (isMobile()) {
      //   window.addEventListener('pagehide', handleBeforeUnload);
      //   document.addEventListener('visibilitychange', onVisibilityChange);
      window.addEventListener('focus', handleFocus);
      window.addEventListener('blur', handleBeforeUnload);
    } else {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }
    return () => {
      if (socket) socket.disconnect();
      if (isMobile()) {
        window.removeEventListener('focus', handleFocus);
        document.removeEventListener('blur', handleBeforeUnload);
      } else {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      }
    };
  }, []);

  return (
    <div className="w-full order-3 relative vb-moi">
      <div className={twMerge('border h-full', BORDER_COLORS.primary)}>
        <div className="title">
          <a href="#" className="font-semibold">
            {t('home.accessStatitics')}
          </a>
        </div>
        <div className="body">
          <div className="TD-div-module-thongke text-3xl block text-center px-3 pt-4">
            <a className={twMerge('font-bold w-full', COLORS.primary)}>{formatNumber(dataViews?.totalView ?? 0)}</a>
          </div>
          <div className="current-online block text-center pb-5 pt-1"> {formatNumber(dataViews?.lastConnectView ?? 0)} người đang online</div>
        </div>
      </div>
    </div>
  );
};

export default AccessInformation;
